import { z } from 'zod';
export const PLATFORM_SETTING_KEYS = ['openai_admin_key'];
export const platformSettingsSchema = z.object({
    openai: z.object({
        configured: z.boolean(),
        lastValidatedAt: z.string().nullable(),
        lastValidatedStatus: z.enum(['ok', 'failed']).nullable(),
        updatedAt: z.string().nullable(),
    }),
});
export const setOpenAIAdminKeySchema = z.object({
    adminKey: z.string().trim().min(20).max(512),
});
